// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"48518":"c9ee3f8f75d24b5a","86779":"567d5be95c9ad14a"}[chunkId] + ".css";
};